import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <path d="M640-80 240-480l400-400 71 71-329 329 329 329-71 71Z" />,
  'ArrowBackIos',
  '0 -960 960 960',
)
